import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormControl,
  FormControlLabel,
  FormHelperText,
  FormLabel,
  IconButton,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  TextField,
  TextareaAutosize,
} from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";
import CloseIcon from "@mui/icons-material/Close";

import React from "react";
import ImageUploader from "../../utils/MultipleImageUploader";
import { LoadingButton } from "@mui/lab";
import { emailValidator, mobileValidator } from "../../utils";
const Categories = ["Please Select Category","Supply Chain", "Marketing", "Operations"];

const ManageVendor = (props) => {
  return (
    <Dialog
      maxWidth="sm"
      fullWidth="false"
      sx={{ zIndex: 1000 }}
      open={true}
      onClose={props?.handleCloseDialog}
    >
      <DialogTitle
        sx={{
          m: 0,
          p: 1,
          width: "600px",
          textAlign: "start",
          color: "#044A2A",
        }}
      >
        {props?.isEdit ? "Edit" : "Add"} Vendor Gateway
      </DialogTitle>

      <IconButton
        aria-label="close"
        onClick={props?.handleCloseDialog}
        sx={{
          position: "absolute",
          right: 3,
          top: 3,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <CloseIcon />
      </IconButton>

      <Divider />

      <DialogContent style={{ maxWidth: "600px" }}>
        <div className="w-full max-w-7xl">
          <FormControl sx={{ m: 1, minWidth: "45%", border: "none" }}>
            <TextField
              size="small"
              label="Vendor Name"
              variant="outlined"
              required
              error={
                props?.modified && !props?.selectedItem?.vchVendorName
                  ? true
                  : ""
              }
              value={props?.selectedItem?.vchVendorName}
              onChange={(e) => {
                props?.handleChange(e.target.value, "vchVendorName");
              }}
            />
            <div style={{ color: "red" }}>
              {props?.modified && !props?.selectedItem?.vchVendorName && (
                <FormHelperText style={{ color: "red" }}>
                  {"Please enter vendor name"}
                </FormHelperText>
              )}
            </div>
          </FormControl>
          <FormControl sx={{ m: 1, minWidth: "45%", border: "none" }}>
            <TextField
              size="small"
              label="Vendor Url"
              variant="outlined"
              required
              error={
                props?.modified && !props?.selectedItem?.vchVendorURL
                  ? true
                  : ""
              }
              value={props?.selectedItem?.vchVendorURL}
              onChange={(e) => {
                props?.handleChange(e.target.value, "vchVendorURL");
              }}
            />
            <div style={{ color: "red" }}>
              {props?.modified && !props?.selectedItem?.vchVendorURL && (
                <FormHelperText style={{ color: "red" }}>
                  {"Please enter vendor url"}
                </FormHelperText>
              )}
            </div>
          </FormControl>
        </div>
        <div className="w-full max-w-7xl">
          <FormControl sx={{ m: 1, minWidth: "45%", border: "none" }}>
            <FormLabel
              id="demo-row-radio-buttons-group-label"
              style={{ fontSize: "0.75rem" }}
            >
              How will the Vendor receive Information ?
            </FormLabel>
            <RadioGroup
              row
              value={props?.selectedItem?.vchPost}
              aria-labelledby="demo-row-radio-buttons-group-label"
              name="row-radio-buttons-group"
              onChange={(e) => props?.handleChange(e.target.value, "vchPost")}
            >
              <FormControlLabel
                value="GET"
                control={<Radio size="small" />}
                label={
                  <span style={{ fontSize: "0.75rem" }}>{"URL Post"}</span>
                }
              />
              <FormControlLabel
                value="POST"
                control={<Radio size="small" />}
                label={
                  <span style={{ fontSize: "0.75rem" }}>{"Form Post"}</span>
                }
              />
            </RadioGroup>
          </FormControl>
          <FormControl sx={{ m: 1, minWidth: "45%", border: "none" }}>
            <Select
              variant="outlined"
              size="small"
              // label={"Category"}
              placeholder="Category"
              value={props?.selectedItem?.vchCategory || Categories[0]}
              onChange={(e) =>
                props?.handleChange(e.target.value, "vchCategory")
              }
            >
              {Categories?.map((i) => (
                <MenuItem key={i} value={i}>
                  {i}
                </MenuItem>
              ))}
            </Select>{" "}
            <div style={{ color: "red" }}>
              {props?.modified && (!props?.selectedItem?.vchCategory || props?.selectedItem?.vchCategory==="Please Select Category") && (
                <FormHelperText style={{ color: "red" }}>
                  {"Please Select Category"}
                </FormHelperText>
              )}
              </div>
          </FormControl>
        </div>
        <div className="w-full max-w-7xl">
          <FormControl sx={{ m: 1, minWidth: "45%", border: "none" }}>
            <TextField
              size="small"
              label="Vendor Email"
              variant="outlined"
              type="email"
              required
              error={
                props?.modified && !props?.selectedItem?.vchEmail
                  ? true
                  : ""
              }
              value={props?.selectedItem?.vchEmail}
              onChange={(e) => {
                props?.handleChange(e.target.value, "vchEmail");
              }}
            />
            <div style={{ color: "red" }}>
              {props?.modified && emailValidator(props?.selectedItem?.vchEmail) && (
                <FormHelperText style={{ color: "red" }}>
                 {emailValidator(props?.selectedItem?.vchEmail)}
                </FormHelperText>
              )}
            </div>
          </FormControl>
          <FormControl sx={{ m: 1, minWidth: "45%", border: "none" }}>
            <TextField
              size="small"
              type="tel"
              label="Vendor Phone Number"
              variant="outlined"
              value={props?.selectedItem?.vchPhoneNumber}
              onChange={(e) => {
                props?.handleChange(e.target.value, "vchPhoneNumber");
              }}
            />
            <div style={{ color: "red" }}>
              {props?.modified &&  props?.selectedItem?.vchPhoneNumber && mobileValidator(props?.selectedItem?.vchPhoneNumber) && (
                <FormHelperText style={{ color: "red" }}>
                {mobileValidator(props?.selectedItem?.vchPhoneNumber)}
                </FormHelperText>
              )}
            </div>
          </FormControl>
        </div>
        <div>
          <FormControl sx={{ m: 1, minWidth: "100%", border: "none" }}>
            <TextareaAutosize
              size="small"
              placeholder="Vendor Description"
              minRows={3}
              label="Vendor Description"
              variant="outlined"
              required
              error={
                props?.modified && !props?.selectedItem?.vchVendorDescription
                  ? true
                  : ""
              }
              value={props?.selectedItem?.vchVendorDescription}
              onChange={(e) => {
                props?.handleChange(e.target.value, "vchVendorDescription");
              }}
            />
            <div style={{ color: "red" }}>
              {props?.modified &&
                !props?.selectedItem?.vchVendorDescription && (
                  <FormHelperText style={{ color: "red" }}>
                    {"Please enter vendor description"}
                  </FormHelperText>
                )}
            </div>
          </FormControl>
        </div>
        <div>
          <ImageUploader
            showUploadButton={props?.selectedItem?.images?.length === 0}
            previouslyUploadedImages={props?.selectedItem?.images}
            sendImageDataToParent={props?.handleImage}
          />
          <div>
            {props?.modified && props?.selectedItem?.images?.length === 0 && (
              <FormHelperText
                style={{
                  color: "red",
                  textAlign: "center",
                  paddingTop: "0.5rem",
                }}
              >
                {"Please upload vendor image"}
              </FormHelperText>
            )}
          </div>
        </div>
      </DialogContent>
      <Divider />

      <DialogActions
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <LoadingButton
          variant="contained"
          color="success"
          startIcon={<SaveIcon />}
          loading={props?.btnLoading}
          loadingPosition="start"
          style={{ background: "green" }}
          onClick={() => props?.handleSubmit()}
        >
          {props?.isEdit ? "Update" : "Add"}
        </LoadingButton>
        <Button
          disabled={props?.btnLoading}
          variant="contained"
          color="error"
          style={{ backgroundColor: "#d32f2f" }}
          onClick={props?.handleCloseDialog}
        >
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ManageVendor;
